import { Pipe, PipeTransform } from '@angular/core';
import { UiAuthService } from '@fullyops/legacy/ui';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'momentTimezoneToAngularTimezone',
  standalone: true,
})
export class MomentTimezoneToAngularTimezonePipe implements PipeTransform {
  constructor(protected uiAuthService: UiAuthService) {
    moment.locale(this.uiAuthService.currentUser.locale);
  }

  transform(date: string | Date, format?: string): string {
    if (!format) {
      format = 'LL';
    }

    return moment
      .tz(date, this.uiAuthService.currentUser.timeZone)
      .format(format);
  }
}
